import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import Modal from 'react-modal'
import 'less/views/widgets/globalWaitDialog.less'

const TRANSLATIONS = {
  de: "Bitte warten...",
  en: "Please wait..."
}

const DEFAULT_LANGUAGE = "de"

// Hole Sprache aus localStorage oder nutze Default
const getLanguage = () => localStorage.getItem("lang") || DEFAULT_LANGUAGE

class RequestTracker {
  constructor() {
    this.activeRequests = 0
    this.listeners = new Set()
  }

  addListener(callback) {
    this.listeners.add(callback)
    return () => this.listeners.delete(callback)
  }

  notifyListeners() {
    this.listeners.forEach(callback => callback())
  }

  incrementRequests() {
    this.activeRequests++
    this.notifyListeners()
  }

  decrementRequests() {
    this.activeRequests = Math.max(0, this.activeRequests - 1)
    this.notifyListeners()
  }

  isLoading() {
    return this.activeRequests > 0
  }
}

export const requestTracker = new RequestTracker()

// Wait Dialog Komponente
function GlobalWaitDialog() {
  const [isLoading, setIsLoading] = useState(false)
  const waitText = TRANSLATIONS[getLanguage()] || TRANSLATIONS.de

  useEffect(() => {
    const onChange = () => {
      setIsLoading(requestTracker.isLoading())
    }
    
    // Cleanup-Funktion wird von addListener zurückgegeben
    const removeListener = requestTracker.addListener(onChange)
    return removeListener
  }, [])

  return (
    <Modal
      isOpen={isLoading}
      className="wait-dialog"
      overlayClassName="wait-dialog-overlay"
      contentLabel={waitText}
    >
      <div className="wait-dialog-content">
        <div className="spinner"></div>
        <div className="message">{waitText}</div>
      </div>
    </Modal>
  )
}

// Render in DOM
const waitDialogContainer = document.getElementById('globalSpinner')
if (waitDialogContainer) {
  ReactDOM.render(<GlobalWaitDialog />, waitDialogContainer)
}

export default GlobalWaitDialog
